import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wallet } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";

export default function ConnectCard() {
  const { t } = useLang();
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [needsActivation, setNeedsActivation] = useState(false);
  useEffect(() => { api.get("/stripe/connect/status").then((r) => setState(r.data)).catch(() => setState({ onboarded: false })); }, []);
  const start = async () => {
    setBusy(true); setNeedsActivation(false);
    try {
      const r = await api.post("/stripe/connect/onboard", {});
      window.location.href = r.data.onboarding_url;
    } catch (e) {
      const status = e?.response?.status;
      const detail = e?.response?.data?.detail || "";
      if (status === 503 || /Connect/i.test(detail)) {
        setNeedsActivation(true);
      } else {
        toast.error(detail || t("dash.toast_error"));
      }
      setBusy(false);
    }
  };
  const status = state?.onboarded ? "done" : (state?.details_submitted ? "pending" : (state?.account_id ? "pending" : "new"));
  const badge = { done: "bg-sage text-white", pending: "bg-yellow-500/20 text-yellow-800", new: "bg-muted text-muted-foreground" }[status];
  const labelKey = { done: "dash.connect_done", pending: "dash.connect_pending", new: "dash.connect_start" }[status];
  return (
    <div className="border border-border rounded-lg p-5 bg-card" data-testid="connect-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Wallet className="w-4 h-4 text-sage"/>
          <span className="uppercase tracking-[0.2em] text-[10px] text-muted-foreground">{t("dash.stripe_connect")}</span>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full ${badge}`} data-testid="connect-status">{t(labelKey)}</span>
      </div>
      <p className="text-xs text-muted-foreground mb-4">{t("dash.connect_hint")}</p>
      {needsActivation ? (
        <div className="border-l-2 border-primary bg-primary/5 p-3 mb-3 text-xs" data-testid="connect-activation-banner">
          <div className="font-semibold text-primary mb-1">Attiva Stripe Connect</div>
          <p className="text-muted-foreground mb-2">Devi abilitare Connect una sola volta sul tuo account Stripe. Dopo, i pagamenti diretti verranno divisi automaticamente.</p>
          <a href="https://dashboard.stripe.com/connect" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline font-semibold">
            → dashboard.stripe.com/connect
          </a>
        </div>
      ) : null}
      <Button size="sm" onClick={start} disabled={busy} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 lift" data-testid="connect-start-btn">
        {status === "done" ? t("dash.connect_continue") : (status === "pending" ? t("dash.connect_continue") : t("dash.connect_start"))}
      </Button>
    </div>
  );
}
